import { z } from 'zod'

import {
  BidDomainSelectModelSchema,
  ClientTermsAgreementSchema,
  CreditTermsAgreementSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

export const AcceptBidInputSchema = BidDomainSelectModelSchema.pick({
  bidId: true,
}).extend({
  agreements: z
    .array(z.union([ClientTermsAgreementSchema, CreditTermsAgreementSchema]))
    .min(1),
})

export type AcceptBidInput = ZodInfer<typeof AcceptBidInputSchema>

export const AcceptBidOutputSchema = SelectBidOutputSchema

export type AcceptBidOutput = ZodInfer<typeof AcceptBidOutputSchema>
